import { action, computed, makeObservable, observable } from 'mobx';
import { RootNode, LayerGroupNode, LayerNode } from './Tree';
import { TableLayerNode } from './Tree/TableLayerNode';
import { NodeStatus } from './Tree/types';

export class TreeViewer {
  @observable private _displayedNode:
    | RootNode
    | LayerGroupNode
    | TableLayerNode;
  @observable private _path: (RootNode | LayerGroupNode | TableLayerNode)[] =
    [];

  constructor(tree: RootNode) {
    this._displayedNode = tree;
    this._path.push(tree);
    this._loadDisplayedNode();
    makeObservable(this);
  }

  @computed get displayedNode() {
    return this._displayedNode;
  }

  @computed get path() {
    return [...this._path];
  }

  @action goToChild = (name: string) => {
    if (this._displayedNode instanceof TableLayerNode) return;

    const child = this._findChild(name, this._displayedNode);

    if (child instanceof LayerNode) return;

    this._displayedNode = child;
    this._path.push(child);
    this._loadDisplayedNode();
  };

  @action goToParent = () => {
    if (this._displayedNode instanceof RootNode) return;

    this._displayedNode = this._displayedNode.parent;
    this._path.pop();
  };

  /** Переход к ноде в ветке. Для возвращения в `Root` необходимо передать name = undefined  */
  @action goToPathNode = (name?: string) => {
    const index = this._findBranchNodeIndex(name);

    if (index === undefined) {
      throw new Error(
        `Не найдена нода в текущей ветке с именем ${name || 'Root'}`,
      );
    }

    const node = this._path[index];

    if (node === undefined) {
      throw new Error(`Не найдена нода с индексом ${index}`);
    }

    this._displayedNode = node;
    this._path.splice(index + 1, this._path.length);
  };

  private _findBranchNodeIndex(name?: string): number | undefined {
    if (name === undefined) return 0;

    const index = this._path.findIndex((node) => {
      if (node instanceof RootNode) {
        return name === undefined;
      }

      return node.layer.layer_name === name;
    });

    if (index === -1) return;

    return index;
  }

  private _findChild(name: string, node: RootNode | LayerGroupNode) {
    const child = node.children.find((node) => node.layer.layer_name === name);

    if (!child) {
      throw new Error(
        `У нода с именем ${this._displayedNode.name} не содержит ноды с именем ${name} `,
      );
    }

    return child;
  }

  private _loadDisplayedNode() {
    if (this._displayedNode.childrenStatus === NodeStatus.notLoaded) {
      this._displayedNode.load();
    }
  }
}
